import AbstractDataAdapter from './AbstractDataAdapter';
import { toApiOrgType } from '../helpers/organizationTypes';

class RealmDataAdapter extends AbstractDataAdapter {
  /**
   *
   * @returns {string[]}
   */
  static get allowedFields() {
    return [
      'name',
      'websiteUrl',
      'organizationType',
      'addressOne',
      'addressTwo',
      'postalCode',
      'countryId',
      'cityId',
      'managerId',
      // The two service activations. Sent as booleans, and false has to travel:
      // turning a service off is an act, not an omission.
      'communityEnabled',
      'conciergeEnabled',
    ];
  }

  /**
   *
   * @returns {string[]}
   */
  static get requiredFields() {
    return ['name', 'organizationType'];
  }

  static sendableAttributeRule(attribute) {
    if (attribute === 'organizationType') {
      return 'type';
    }
    return super.sendableAttributeRule(attribute);
  }

  static convertFieldsToBackendFormat(model) {
    const sendableAttributes = super.convertFieldsToBackendFormat(model);
    return {
      ...sendableAttributes,
      type: toApiOrgType(sendableAttributes.type),
    };
  }
}

export default RealmDataAdapter;
